import React, { useEffect, useState } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import smallLogo from "../media/small_logo.svg";
import { api } from "../utils/api";
import getInitials from "../utils/getInitials";

const Fridge = () => {
  const [meals, setMeals] = useState([]);
  const [report, setReport] = useState([]);

  const navigator = useNavigate();

  useEffect(() => {
    Promise.all([api.getMeals({ p: 1, s: 10000 }), api.getFridge()])
      .then(([{ meals }, { report }]) => {
        setMeals(meals);
        setReport(report);
      })
      .catch((err) => err.status === 403 && navigator("/access_denied"));
  }, []);

  const totalUnits = report.reduce((acc, cur) => acc + Number(cur.count || 0), 0);
  const totalPositions = report.length;
  const summaryCards =
    totalUnits === totalPositions
      ? [{ label: "Всего", value: totalPositions }]
      : [
          { label: "Позиций", value: totalPositions },
          { label: "Единиц", value: totalUnits },
        ];

  const renderOwners = (owners = []) => {
    const visible = owners.slice(0, 3);
    const remaining = owners.length - visible.length;
    return (
      <div className="owner-stack">
        {visible.map((owner, idx) => {
          const name = typeof owner === "object" ? owner.name : owner;
          const avatar = typeof owner === "object" ? owner.avatar : null;
          const initials = getInitials(name) || "?";
          return (
            <span
              className={`owner-badge${avatar ? " avatar" : ""}`}
              key={`${name}-${idx}`}
              title={name}
            >
              {avatar ? <img src={avatar} alt={name} /> : initials}
            </span>
          );
        })}
        {remaining > 0 ? <span className="owner-badge muted">+{remaining}</span> : ""}
      </div>
    );
  };

  return (
    <>
      <div className="page-header">
        <div className="title-wrap">
          <div className="chip">
            <i className="bi bi-box-seam" />
            Холодильник
          </div>
          <div>
            <h1 className="fw-bold mb-1">Холодильник</h1>
            <p className="page-subtitle m-0">Что осталось и кто заказывал</p>
          </div>
        </div>
      </div>
      <div className="fridge-summary">
        {summaryCards.map((card) => (
          <div className="stat-card" key={card.label}>
            <span className="stat-label">{card.label}</span>
            <span className="stat-value">{card.value}</span>
          </div>
        ))}
      </div>
      <div className="card-grid">
        {report.length > 0 ? (
          report.map((item) => (
            <Card
              key={item.name}
              className="glass-panel fridge-card"
            >
              <div className="fridge-thumb wide">
                <img
                  src={
                    meals.find((el) => el.name === item.name)?.image
                      ? meals.find((el) => el.name === item.name).image
                      : smallLogo
                  }
                  alt={item.name}
                />
              </div>
              <p className="m-0 fw-bold fridge-name mt-2">{item.name}</p>
              <div className="count-badge mb-2">Осталось: {item.count} шт.</div>
              <OverlayTrigger
                trigger="click"
                placement="auto"
                rootClose={true}
                overlay={<Tooltip placement="auto">{item.owners.join(", ")}</Tooltip>}
              >
                <div className="fridge-card__owners" style={{ cursor: "pointer" }}>
                  <span className="text-muted small">Кто заказывал:</span>
                  {renderOwners(item.owners)}
                </div>
              </OverlayTrigger>
            </Card>
          ))
        ) : (
          <p className="fs-3">Ничего нет...</p>
        )}
      </div>
    </>
  );
};

export default Fridge;
